/**
 * friendlyQuotaError — one place that turns quota 402 bodies into a human
 * why+how sentence. Handles BOTH shapes:
 *  - flat quotaGate body: { code, resource, limit, current } (preferred);
 *  - legacy: JSON stringified into `message` (older server payloads).
 */
export function friendlyQuotaError(e: any, fallback: string): string {
  const body = e?.response?.data;
  let q: any = body && typeof body === 'object' && body.code === 'quota_exceeded' ? body : null;
  if (!q) {
    const msg = body?.message ?? e?.message;
    if (typeof msg === 'string' && msg.includes('quota_exceeded')) {
      try { q = JSON.parse(msg); } catch { /* fall through */ }
    }
  }
  if (q && q.code === 'quota_exceeded') {
    // QUOTA-MED-01: resource-aware copy — vehicle/crew/seat each name their own
    // resource (vehicle used to render as "Seat").
    const RES: Record<string, [string, string]> = {
      crew: ['Crew', 'crew'],
      vehicle: ['Vehicle', 'vehicle'],
      seat: ['Seat', 'seat'],
    };
    const [what, thing] = RES[q.resource] ?? RES.seat;
    return `${what} limit reached (${q.current}/${q.limit}) — remove an unused ${thing} or upgrade your plan to add more.`;
  }
  const msg = body?.message ?? e?.message;
  return msg || fallback;
}
